import React from 'react';
import { Table } from 'semantic-ui-react';
import range from 'lodash/range';
import {
    Header, Cell, renderPrice, EmptyCell, Title
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    }
};

const FMBMatrix = props => {

    const { data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div ref={ref} style={styles.root} className='print landscape'>
            <div>
                <Trigger />
            </div>

            <Title data={Object.values(data)} title='Tower FBM'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>

                <Table.Header>
                    <Table.Row>
                        <Header colSpan='4' content='West View' />
                        <Header colSpan='4' content='South View' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='D-1191 sq ft' />
                        <Header colSpan='2' content='E-1115 sq ft' />
                        <Header colSpan='2' content='B-1056 sq ft' />
                        <Header colSpan='2' content='B-1056 sq ft' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row>
                        <Cell unit='0604' price={renderPrice(data['595-0604'], matrixType)} status={data['595-0604'].status}/>
                        <Cell unit='0605' price={renderPrice(data['595-0605'], matrixType)} status={data['595-0605'].status}/>
                        <EmptyCell count={2} />
                    </Table.Row>
                    {
                        range(7, 21)
                            .filter(num => num !== 13)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            }))
                            .map(floor => (
                                <Table.Row key={`floor-${floor}`}>
                                    {['04', '05', '02', '06'].map(unit_num => (
                                        <Cell
                                            key={`${floor}${unit_num}`}
                                            unit={`${floor}${unit_num}`}
                                            price={renderPrice(data[`595-${floor}${unit_num}`], matrixType)}
                                            status={data[`595-${floor}${unit_num}`].status}
                                        />
                                    ))}
                                </Table.Row>
                            ))
                    }


                </Table.Body>
            </Table>

            <div className='pagebreak' />
            <div className='printspace' />
            <Title title='Tower FBM'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>

                <Table.Header>
                    <Table.Row>
                        <Header colSpan='6' content='North View' />
                        <Header colSpan='4' content='East View' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='C-993 sq ft' />
                        <Header colSpan='2' content='1-1-A' />
                        <Header colSpan='2' content='C-993 sq ft' />
                        <Header colSpan='2' content='D-1191 sq ft' />
                        <Header colSpan='2' content='E-1115 sq ft' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {
                        range(6, 21)
                            .filter(num => num !== 13)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            }))
                            .map(floor => (
                                <Table.Row key={`floor-${floor}`}>
                                    {['03', '01', '07', '08', '09'].map(unit_num => (
                                        <Cell
                                            key={`${floor}${unit_num}`}
                                            unit={`${floor}${unit_num}`}
                                            price={renderPrice(data[`595-${floor}${unit_num}`], matrixType)}
                                            status={data[`595-${floor}${unit_num}`].status}
                                        />
                                    ))}
                                </Table.Row>
                            ))
                    }

                </Table.Body>
            </Table>

        </div>
    );


};

export default FMBMatrix;
